<script lang="ts">
    import { onMount } from 'svelte';
    import { loading } from '$lib/stores/loadingStore';
    export let color = '#4682B4';
  
    let progress = 0;
    let visible = false;
    let timeoutId: NodeJS.Timeout;
  
    $: if ($loading) {
      startLoading();
    } else {
      completeLoading();
    }
  
    function startLoading() {
      visible = true;
      progress = 0;
      animateProgress();
    }
  
    function animateProgress() {
      timeoutId = setTimeout(() => {
        if (progress < 90) {
          progress += (90 - progress) * 0.1;
          animateProgress();
        }
      }, 100);
    }
  
    function completeLoading() {
      clearTimeout(timeoutId);
      progress = 100;
      setTimeout(() => {
        visible = false;
        progress = 0;
      }, 300);
    }
  
    onMount(() => {
      return () => clearTimeout(timeoutId);
    });
  </script>
  
  {#if visible}
    <div class="loading-bar-container">
      <div class="loading-bar" style="width: {progress}%; background-color: {color};"></div>
    </div>
  {/if}
  
  <style>
    .loading-bar-container {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 3px;
      background-color: rgba(255, 255, 255, 0.1);
      z-index: 9999;
    }
  
    .loading-bar {
      height: 100%;
      transition: width 0.1s ease;
      box-shadow: 0 0 10px rgba(25, 155, 225, 0.7);
    }
  </style>